import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {Link, useLocation} from "react-router-dom";

export function VehicleEventView() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };


    const job = useLocation().state?.job
    const vehicle = useLocation().state?.vehicle


    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div>


                    {/* this is broken */}
                    <Link to={"/management/jobs/view"} state={job}>
                        <button className="btn btn-secondary float-start m-0 pb-0 pt-0">← Overview</button>
                    </Link>
                    <br/>

                    <div className="page-title-sh26">
                        <h1>Timeline for {vehicle.licencePlate}</h1>
                        <p> Company name: {job.name}, ID: #{job.id}</p>
                        <hr/>
                    </div>


                    <div className=" w-25 h-100 float-start timeline timeline-vehicle">
                        <div className="timeline-button float-start timeline-button-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                        <div className=" timeline-button float-start ">
                        </div>
                        <div className="timeline-section"></div>

                        <div className="timeline-button float-start">
                        </div>
                        <div className="timeline-section"></div>

                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Installation for Vehicle booked</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {vehicle.vehicleDates.installationBooked}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Vehicle arrived at CubeWraps</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {vehicle.vehicleDates.vehicleArrived}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Pre-wrapping checklist submitted</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {vehicle.vehicleDates.preChecklist}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Vehicle Wrapped </h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {vehicle.vehicleDates.vehicleWrapped}
                        </p>
                    </div>

                    <div className="list-section w-75 float-end timeline-section">
                        <h4 className="list-section-header"> Post-wrapping checklist submitted</h4>
                        <p className="list-section-date-time text-secondary pt-1">
                            <br/>
                            {vehicle.vehicleDates.postChecklist}
                        </p>
                    </div>

                </div>

                <div className="page-break w-100 ">
                    <p> . </p>
                </div>

            </AuthenticatedTemplate>
        </div>
    );
}
